import { motion } from 'framer-motion';
import { Phone, Navigation } from 'lucide-react';
import { PHONE_NUMBER } from '../data/menu';
import { DIRECTIONS_URL } from '../data/business';

export function FloatingCallButton() {
  return (
    <>
      {/* Floating Directions Button — Bottom Left */}
      <motion.a
        href={DIRECTIONS_URL}
        target="_blank"
        rel="noopener noreferrer"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1.2, type: 'spring', stiffness: 200 }}
        whileHover={{ scale: 1.15 }}
        whileTap={{ scale: 0.9 }}
        className="fixed bottom-6 left-6 z-50 bg-[#6B1C23] text-white hover:bg-[#8B2430] p-4 rounded-full shadow-lg shadow-[#6B1C23]/30 transition-colors duration-300"
        data-testid="floating-directions-btn"
      >
        <Navigation className="w-6 h-6" />
      </motion.a>

      {/* Floating Call Button — Bottom Right */}
      <motion.a
        href={`tel:${PHONE_NUMBER}`}
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1, type: 'spring', stiffness: 200 }}
        whileHover={{ scale: 1.15 }}
        whileTap={{ scale: 0.9 }}
        className="fixed bottom-6 right-6 z-50 bg-[#6B1C23] text-white hover:bg-[#8B2430] p-4 rounded-full shadow-lg shadow-[#6B1C23]/30 transition-colors duration-300"
        data-testid="floating-call-btn"
      >
        <Phone className="w-6 h-6" />
      </motion.a>
    </>
  );
}
